import { Box, styled } from '@mui/material';

export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }

  padding: 20px 0 0 0;
  height: 100vh;
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const SidebarContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;

export const EditProductsWrapper = styled(Box)`
  position: relative;
  width: 100%;
`;
